export function serializeMemory(buffer: Uint8Array): string
{
    return btoa(Array.from(buffer)
        .map((byte: number) => String.fromCharCode(byte))
        .join(''),
    );
}

export function deserializeMemory(data: string): Uint8Array
{
    const binaryString: string     = atob(data);
    const memoryBuffer: Uint8Array = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
        memoryBuffer[i] = binaryString.charCodeAt(i);
    }

    return memoryBuffer;
}
